import { LoaderFunction } from 'react-router-dom'

import { certificatesApi } from '../../services/certificates'
import type { AppStore } from '../../store'

export const certificatesLoader = (store: AppStore) =>
  (async () => {
    const { data } = await store.dispatch(
      certificatesApi.endpoints.listCertificates.initiate(undefined, { forceRefetch: true })
    )

    return data
  }) satisfies LoaderFunction
